// extracted by mini-css-extract-plugin
export default {"imageWrapper":"yE-z","hovered":"zE-z","hoverImage":"AE-z","mainImage":"BE-z","imageNoBackground":"CE-z","fullSizeImage":"DE-z"};